import React              from "react";
import {default as Reducer} from '@shared/services/session/reducers/platform-sesion-reducer';

const initialState = {
    user: {},
    access_token: null,
    player: {},
    wallet: {},
    balance: 0,
    prepaid_player_id: null,
    prepaid_wallet_id: null,
    error: null,
};

const PlatformSessionStore = ({children}) => {
    const [state, dispatch] = React.useReducer(Reducer, initialState);
    return (
        <PlatformSessionContext.Provider value={[state, dispatch]}>
            {children}
        </PlatformSessionContext.Provider>
    )
};

export const PlatformSessionContext = React.createContext(initialState);
export const usePlatformSessionContext = () => React.useContext(PlatformSessionContext); // the custom hook
export default PlatformSessionStore;